const signIn = "/";
const signUp = "/signup";
const forgetPassword = "/forget-password";
const verifyEmail = "/verify-email";
const welcomeScreen = "/welcomeScreen";
const resetPassword = "/reset-password";
const questionnaire = "/questionnaire";
const mainConsole = "/main-console";
const loginScreen = "/signin";
const businessPartners = "/business-partners"
export {
  signIn,
  signUp,
  forgetPassword,
  verifyEmail,
  welcomeScreen,
  questionnaire,
  resetPassword,
  mainConsole,
  loginScreen,
  businessPartners
};
